import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/optimizer',
        component: () => import('@/layouts/ModuleLayout.vue'),
        meta: {
            moduleKey: 'panel_optimizer',
        },
        children: [
            {
                path: '',
                name: 'optimizer-jobs',
                component: () => import('./views/OptimizerJobList.vue'),
            },
            {
                path: 'new',
                name: 'optimizer-job-new',
                component: () => import('./views/OptimizerJobNew.vue'),
            },
            {
                path: 'templates',
                name: 'optimizer-templates',
                component: () => import('./views/OptimizerTemplateList.vue'),
            },
            {
                path: 'templates/:id',
                name: 'optimizer-template-detail',
                component: () => import('./views/OptimizerTemplateDetail.vue'),
                props: true,
            },
            {
                path: 'presets',
                name: 'optimizer-presets',
                component: () => import('./views/MaterialPresetList.vue'),
            },
            {
                path: 'presets/new',
                name: 'optimizer-preset-new',
                component: () => import('./views/MaterialPresetNew.vue'),
            },
            {
                path: 'presets/:id',
                name: 'optimizer-preset-detail',
                component: () => import('./views/MaterialPresetDetail.vue'),
                props: true,
            },
            {
                // Must be last — :id is a catch-all param
                path: ':id',
                name: 'optimizer-job-detail',
                component: () => import('./views/OptimizerJobDetail.vue'),
                props: true,
            },
        ],
    },
]

export default routes
